import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
      component: () => import('../views/home.vue'),

  },
  {
    path: "/partner",
    name: "contacts",
      component: () => import('../views/contacts.vue'),
  },
  {
    path: "/finished",
    name: "finished",
      component: () => import('../views/finished.vue'),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
